export default "__VITE_ASSET__83df9f9f__"